import { Chip, Divider } from "@mui/joy";
import { useGetCommentsFromStageChangesQuery } from "../../features/empresas/empresaApi";
import { useState } from "react";
import { CommentQueryOptions } from "../../types/empresa";
import { ComentarioCard } from "./ComentarioCard";

interface Props {
    empresaId: number;
}

export function ComentariosDeals({ empresaId }: Props) {
    const [showCurrent, setShowCurrent] = useState(true);
    const [showPrevious, setShowPrevious] = useState(false);

    const { 
        data: currentStageChanges,
        isSuccess
    } = useGetCommentsFromStageChangesQuery({ empresaId, ...{} as CommentQueryOptions});

    const { 
        data: previousStageChanges,
        isSuccess: previousIsSuccess
    } = useGetCommentsFromStageChangesQuery({ empresaId, ...{ dealType: "Previous", totalDeals: "5" } });

    if(isSuccess)
        console.log(currentStageChanges[0]);

    return (
        <div className="border-0 border-red-800 overflow-auto">
            <div className="my-2">
                <Divider>
                    <Chip 
                        variant="soft"
                        color="neutral"
                        size="sm"
                        onClick={() => setShowCurrent(!showCurrent)}>
                    Campaña Actual
                    </Chip>
                </Divider>
                
                <div className={`overflow-auto ${showCurrent ? "h-[200px]": "h-0"} transition-all duration-300`}>
                {isSuccess && 
                currentStageChanges[0] &&
                currentStageChanges[0].comments.length > 0
                ?
                <>
                {currentStageChanges[0]?.comments.map((comm, index) => (
                    <ComentarioCard
                        key={index}
                        comm={comm} />
                ))}
                </>
                :
                <>
                <p className="text-center font-semibold my-2">No hay comentarios</p>
                </>}
                </div>
            </div>
            <div className="my-2">
                <Divider>
                    <Chip
                    variant="outlined"
                    color="neutral"
                    size="sm"
                    onClick={() => setShowPrevious(!showPrevious)}>
                    Campañas Anteriores: {previousStageChanges?.length}
                    </Chip>
                </Divider>
                <div className={`overflow-auto ${showPrevious ? "h-[200px]": "h-0"} transition-all duration-300`}>
                    {previousIsSuccess && previousStageChanges.length > 0
                    ?
                    <>
                    {previousIsSuccess && previousStageChanges.map((deal, index) => (
                        <div key={index}>
                            <p>Campaña: {deal.fechaDeal}</p>
                            {deal.comments.length > 0
                            ?
                            <>
                            {deal.comments.map((comm, index) => (
                                <ComentarioCard
                                    key={index}
                                    comm={comm} />
                            ))}
                            </>
                            : <p className="text-center font-semibold my-2">No hay comentarios en esta campañas</p>
                            }
                        </div>
                    ))}
                    </>
                    :
                    <>
                    <p className="text-center font-semibold my-2">No hay campañas anteriores</p>
                    </>}
                </div>
            </div>
        </div>
    );
}